import { type ReactElement } from "react";

import { cn } from "../utils/cn";
import { SCORE_DIMENSIONS, scoreBgStyle, scoreColorStyle, type SubScores } from "./scoring";

export interface SubScoreBarsProps {
  sub: SubScores;
  compact?: boolean;
  className?: string;
}

export function SubScoreBars({ sub, compact = false, className }: SubScoreBarsProps): ReactElement {
  return (
    <div
      role="list"
      aria-label="Sub-Scores"
      className={cn("flex flex-col", compact ? "gap-2" : "gap-3", className)}
    >
      {SCORE_DIMENSIONS.map((d) => {
        const v = sub[d.key] ?? 0;
        const Icon = d.icon;
        return (
          <div key={d.key} role="listitem">
            <div className="mb-1 flex items-baseline justify-between">
              <span
                className={cn(
                  "inline-flex items-center gap-1.5 font-medium text-text-secondary",
                  compact ? "text-[11px]" : "text-xs",
                )}
              >
                <Icon size={compact ? 11 : 12} className="text-text-tertiary" />
                {d.label}
              </span>
              <span
                className={cn(
                  "tabular-nums font-semibold",
                  compact ? "text-[11px]" : "text-[13px]",
                )}
                style={scoreColorStyle(v)}
                aria-label={`${d.label}: ${v}`}
              >
                {v}
              </span>
            </div>
            <div
              className={cn(
                "overflow-hidden rounded-[3px] bg-neutral-100",
                compact ? "h-1" : "h-1.5",
              )}
            >
              <div
                aria-hidden="true"
                style={{ width: `${v}%`, ...scoreBgStyle(v) }}
                className="h-full transition-[width] duration-400 ease-out"
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
